const prodFilters = {
    hideEmptyFilters: function () {
        var numElements = 10; // Number of elements to check
        var className = 'wpfFilterWrapper'; // Class name of the elements
      
        for (var i = 1; i <= numElements; i++) {
          var id = 'wpfBlock_' + i;
          var targetEl = document.querySelector('.' + className + '#' + id);
        
          if (targetEl) {
            var computedStyle = window.getComputedStyle(targetEl);
            if (computedStyle.display === 'none') {
              //console.log("Element with ID " + id + " has the class, id, and display: none style.");
              targetEl.style.display = 'none';
              // If you want to hide the parent container, use:
              // var buttonContainer = targetEl.closest('.accordion');
              // if (buttonContainer) {
              //   buttonContainer.style.display = 'none';
              // }
            }
          }
        }
      }
  };
  
export default prodFilters;